import { useMutation, useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import OdooSOPreview from "components/shared/OdooSOPreview";
import { v4 } from "uuid";
import { FETCH_PLAN_SUMMARY } from "../graphql";
import { SYNC_PLAN_TO_ODOO } from "../syncPlanToOdooViews/graphql";

const CreateIncOdooSoView = ({ planId, hide }) => {
  const { loading, error, data } = useQuery(FETCH_PLAN_SUMMARY, {
    variables: { id: planId },
    fetchPolicy: "network-only",
  });
  const [create, createRes] = useMutation(SYNC_PLAN_TO_ODOO, {
    variables: { planId, instance: "INC", orderType: "SO" },
    onCompleted() {
      Alert("success", "Plan sent to Odoo successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_PLAN_FOR_INC_ODOO"],
    awaitRefetchQueries: true,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const extraData = JSON.parse(data.productionPlan.extraData || "{}");

  const addresses = [extraData.fobCustomer, ...extraData.fobCustomer.child_ids];
  const invoiceAddress = addresses.find(
    (i) => i.id === extraData.invoiceAddressId,
  );
  const deliveryAddress = addresses.find(
    (i) => i.id === extraData.deliveryAddressId,
  );

  const orderLines = data.productionPlan.finalLines.reduce((res, i) => {
    const found = res.find((x) => x.productId === i.product.id);
    if (found)
      return res.map((x) =>
        x.id === found.id ? { ...x, qty: x.qty + i.finalQty } : x,
      );
    return [
      ...res,
      {
        id: v4(),
        productId: i.product.id,
        name: `[${i.product.number}] ${i.product.name}`,
        qty: i.finalQty,
      },
    ];
  }, []);

  return (
    <div className="space-y-6 text-sm">
      <div className="card">
        <OdooSOPreview
          customerName={extraData.fobCustomer.name}
          invoiceAddress={invoiceAddress.contact_address_inline}
          deliveryAddress={deliveryAddress.contact_address_inline}
          warehouseName="Dropship"
          incoterms="FOB"
          orderLines={orderLines}
          hidePrice
        />
      </div>

      <div>
        <Button primary onClick={create} loading={createRes.loading}>
          Create Sales Order
        </Button>
      </div>
    </div>
  );
};

export default CreateIncOdooSoView;
